import {Component, OnDestroy, OnInit} from '@angular/core';
import {ReplaySubject} from 'rxjs';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Router} from '@angular/router';
import {FormHelperService} from '../../../../shared/services/form-helper.service';
import {DictService} from '../../../../shared/services/dict.service';
import {first} from 'rxjs/operators';
import {Uuid} from '../../../../shared/interface/response/uuid';
import {HttpErrorResponse} from '@angular/common/http';
import {RiskService} from '../../../../shared/services/risk.service';
import {InsuranceCompany} from '../../../../shared/interface/insurance-company';

@Component({
  selector: 'app-add-risk',
  templateUrl: './add-risk.component.html',
  styleUrls: ['./add-risk.component.scss']
})
export class AddRiskComponent implements OnInit, OnDestroy {
  riskConfigurationForm: FormGroup;
  insuranceCompanyControl: FormControl;
  internalRiskControl: FormControl;
  importerControl: FormControl;
  processingRequest = false;
  errors: any = {};
  selectedInsuranceCompany: InsuranceCompany;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private snackBar: MatSnackBar,
    private router: Router,
    private fb: FormBuilder,
    private formHelper: FormHelperService,
    private dictService: DictService,
    private riskService: RiskService,
  ) {
    this.riskConfigurationForm = this.fb.group({
      insuranceCompany: this.insuranceCompanyControl = fb.control('', [Validators.required]),
      internalRisk: this.internalRiskControl = fb.control('', [Validators.required]),
      importer: this.importerControl = fb.control(''),
    });
  }

  ngOnInit(): void {

  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  save(): void {
    this.processingRequest = true;
    this.riskService.sendForm(
      this.riskConfigurationForm.value,
    )
      .pipe(
        first()
      )
      .subscribe((response: Uuid) => {
        this.snackBar.open('Pomyślnie utworzono konfigurację', '', {
          duration: 2000,
        });
        this.processingRequest = false;
        this.router.navigate(['/ryzyka', {uuid: response.uuid}]);
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;

        this.snackBar.open('Podczas przesyłania formularza wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });

        if (error.status === 400) {
          this.errors = error.error.error.list;
          this.formHelper.setBackendErrorState(this.riskConfigurationForm, this.errors);
        }
      });
  }

  cancel(): void {
    this.router.navigate(['/ryzyka']);
  }

  insuranceCompanyChanged(insuranceCompany: InsuranceCompany): void {
    this.selectedInsuranceCompany = insuranceCompany;
  }
}
